// tslint:disable:ordered-imports
// Import order is important here.
import './polyfills';
import './publicpath';

import { configureSentry } from './sentry';

import '@atlaskit/css-reset';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';

import { AnalyticsClientImpl } from './clients/AnalyticsClient';
import Analytics from './context/Analytics';
import { createStore } from './store';
import Application from './ui/Application';
import ErrorBoundary from './ui/ErrorBoundary/ErrorBoundary';
// tslint:enable:ordered-imports

configureSentry();

const store = createStore();

// For easier debugging
window.__MOBX_APP_STATE__ = store;

// To avoid updating mobx state outside of an action block
configure({
  enforceActions: 'observed',
});

const analyticsClient = new AnalyticsClientImpl(store.userStore, 'web');

ReactDOM.render(
  <ErrorBoundary subject="root">
    <Provider {...store}>
      <Analytics.Provider value={analyticsClient}>
        <Application />
      </Analytics.Provider>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root'),
);
